"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _TVChartComponent = _interopRequireDefault(require("./TVChartComponent"));
var _tickersActions = require("../../redux/actions/tickersActions");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var decimalPlaces = state.apexCore.product.decimalPlaces;
  return {
    selectedInstrument: selectedInstrument,
    decimalPlaces: decimalPlaces
  };
};
var mapDispatchToProps = {
  changeTickersInterval: _tickersActions.changeTickersInterval
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TVChartComponent["default"]);